import React, { useState, useEffect, useMemo } from 'react';
import { Button, Container, Form, Pagination, Table } from 'react-bootstrap';
import { Point, Predio } from '../../../../service/types/types';
import { PrediosService } from '../../../../service/predios.service';
import { ViewPredioModal } from '../../../common/predios';
import usePagination from '../../../../service/utils/usePagination';

export default function PrediosMapTableSimplificado() {
  const [predios, setPredios] = useState<Predio[]>([]);
  const [search, setSearch] = useState('');

  const filteredPredios = useMemo(() => {
    return predios.filter((p) =>
      [p.name].some((field) =>
        field?.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [predios, search]);

  const { currentPage, totalPages, nextPage, prevPage, currentData, resetPage } = usePagination(filteredPredios, 10);

  useEffect(() => {
    const fetchPredios = async () => {
      try {
        const data = await PrediosService.findAll();
        setPredios(data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchPredios();
  }, []);

  const handleOpenMaps = (location: Point | null) => {
    const [lng, lat] = location?.coordinates || [0, 0];
    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, "_blank"); // abre en nueva pestaña/ventana
  };

  return (
    <Container fluid className="p-0">
      <div style={{ overflowY: 'auto', padding: '1rem' }}>
        {/* 🔎 Buscador */}
        <Form.Control
          type="text"
          placeholder="Buscar por nombre, región o localidad..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            resetPage();
          }}
          className="mb-3"
        />

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Nombre</th>
              <th style={{ width: '220px' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {currentData().map((predio) => (
              <tr key={predio.id}>
                <td>{predio.name}</td>
                <td className="d-flex gap-2">
                  <ViewPredioModal predio={predio} />
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => handleOpenMaps(predio.location)}>
                    Ver en Google
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* 📄 Paginación */}
        {totalPages > 1 && (
          <Pagination className="justify-content-center">
            <Pagination.Prev onClick={prevPage} disabled={currentPage === 1} />
            <Pagination.Item disabled>{`${currentPage} / ${totalPages}`}</Pagination.Item>
            <Pagination.Next onClick={nextPage} disabled={currentPage === totalPages} />
          </Pagination>
        )}
      </div>
    </Container>
  );
}
